<p-progressSpinner class="w-100 text-center resy_spinner" *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
  <div class="pb-4 text-center delete_message">
    <h4>{{'VENUE.CONFIRM_DELETE_MESSAGE'|translate}}</h4>
  </div>
  <div class="d-flex flex-row justify-content-between">
    <button class="create_btn w_45 mt-0" (click)="deleteVenue(venueId)">{{ 'DELETE' |
      translate}}</button>
    <button class="btn_cancel_no_border w_45" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
  </div>
</div>
